<template>
  <div class="centix-selectinput">
    <span class="holder-span" v-on:keyup.esc="$event.target.blur()">
      <select v-model="selected" class="form-control" :disabled="!isEnabled">
        <option v-for="(item, index) in options" :key="index" :value="item.value">
          {{ item.text }}
        </option>
      </select>
    </span>
  </div>
</template>

<script>
export default {
  name: 'SelectInput',
  props: {
    value: {
      required: true
    },
    isEnabled: {
      default: true
    },
    required: {
      default: false
    },
    options: {
      required: true
    }
  },
  model: {
    prop: 'value',
    event: 'value-changed'
  },
  components: {},
  data() {
    return {
      hasFocus: false,
      hasError: false,
      lastError: '',
      localselected: ''
    };
  },
  mounted() {},
  methods: {},
  watch: {
    value() {
      this.localselected = this.value;
    }
  },
  computed: {
    hasValue: function () {
      return this.localselected != null && this.localselected.length > 0;
    },
    showRequiredClass: function () {
      if (this.required && !this.hasValue) {
        return true;
      } else {
        return false;
      }
    },
    selected: {
      get() {
        return this.localselected;
      },
      set(newvalue) {
        this.localselected = newvalue;
        this.$emit('value-changed', newvalue);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'styles/settings.scss';

.centix-selectinput {
  display: inline-block;
  width: 100%;

  select.form-control {
    width: 100%;
    height: 32px;
  }

  .model-state-error {
    color: $error;
  }
}
</style>
